import NewsPage from '@leuven2030/food/News/NewsPage';
import PageLayoutDefault from '@leuven2030/food/Page/PageLayoutDefault';
import PageProps from '@leuven2030/food/Page/PageProps';
import React from 'react';
import { gql } from '@apollo/client';

const SchoolNewsPage = (props) => (
  <NewsPage Layout={PageLayoutDefault} {...props} />
);

export const getStaticProps = PageProps({
  prismic: {
    query: gql`
      {
        allUpdate_groups {
          edges {
            node {
              title
              _meta {
                uid
              }
            }
          }
        }
        allNews_articles(sortBy: published_date_DESC, lang: "nl-be") {
          totalCount
          edges {
            node {
              title
              group {
                ... on Update_group {
                  title
                  color
                  icon {
                    ... on _ImageLink {
                      url
                    }
                  }
                  _meta {
                    uid
                  }
                }
              }
              description
              published_date
              cover {
                ... on _ImageLink {
                  url
                }
              }
              _meta {
                uid
                type
              }
              event_date_start
              event_link
              event_date_end
              event_place
              event_address
            }
            cursor
          }
        }
        news_page(uid: "default", lang: "nl-be") {
          title
          description
          read_more_label
          show_all_label
          recommendations_title
          published_label
          join_event_label
          online_meeting_label
          subscribe_title
          subscribe_button_label
          cover {
            ... on _ImageLink {
              url
            }
          }
          _meta {
            uid
            type
          }
        }
      }
    `
  }
});

export default SchoolNewsPage;
